import { ReactNode } from 'react';

import { useEntityListCardStyles } from './entity-list-card.styles';

interface EntityListCardProps {
  children: ReactNode;
  className?: string;
}

export const EntityListCard = (props: EntityListCardProps) => {
  const { children, className = '' } = props;
  const classes = useEntityListCardStyles();

  return (
    <div
      data-testid="entity-list-card"
      className={`${classes.entityCard} ${className}`}
    >
      {children}
    </div>
  );
};
